<template>
  <div class="pt-12">
    <div class="container">
      <div
        v-if="$slots.title"
        class="flex items-center"
      >
        <slot name="title" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
	name: 'DashboardSection'
}
</script>
